import { Component, Inject } from '@angular/core';
import { defaultSourceModel, SourceModel, SourceType } from '../../models/source.model';
import { MasechtaInterface, MasechtaService } from '../../services/masechta.service';
import { HebrewService } from '../../services/hebrew.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import * as _ from 'lodash';


@Component({
  templateUrl: 'source-dialog.html',
  styleUrls: ['source-dialog.scss'],
})
export class SourceDialogComponent {

  sourceTypes = [
    SourceType.Gemara,
    SourceType.Mishna,
    SourceType.Literal,
  ];

  gemaraStartLocation_daf = null;
  gemaraStartLocation_amud = null;
  gemaraEndLocation_daf = null;
  gemaraEndLocation_amud = null;
  mishnaStartLocation_perek = null;
  mishnaStartLocation_mishna = null;
  mishnaEndLocation_perek = null;
  mishnaEndLocation_mishna = null;

  source:SourceModel;


  gemaraMasechtas:MasechtaInterface[] = [];
  mishnaMasechtas:MasechtaInterface[] = [];

  sizeableArray:Array<any> = new Array(249);

  dafs = [];

  initialSource:any = null;
  mode:'add'|'edit';



  constructor(
    private masechtaService:MasechtaService,
    private hebrewService:HebrewService,
    private dialogRef:MatDialogRef<SourceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private paramData,
  ) {

    if (paramData.source) {
      this.initialSource = paramData.source;
      delete this.initialSource._id;
      this.mode = 'edit';
    } else {
      this.mode = 'add';
    }

    console.log('Mode:', this.mode);
    console.log('Initial source: ', this.initialSource);

  }


  ngOnInit() {

    console.log('ngOninit source dialog');

    if (this.mode === 'add') {
      this.source = _.clone(defaultSourceModel);
    } else {
      this.source = this.initialSource;
      this.gemaraStartLocation_daf = this.source.gemaraStartLocation.daf;
      this.gemaraStartLocation_amud = this.source.gemaraStartLocation.amud;
      this.gemaraEndLocation_daf = this.source.gemaraEndLocation.daf;
      this.gemaraEndLocation_amud = this.source.gemaraEndLocation.amud;
      this.mishnaStartLocation_mishna = this.source.mishnaStartLocation.mishna;
      this.mishnaStartLocation_perek = this.source.mishnaStartLocation.perek;
      this.mishnaEndLocation_mishna = this.source.mishnaEndLocation.mishna;
      this.mishnaEndLocation_perek = this.source.mishnaEndLocation.perek;
    }


    console.log('this.source', this.source);

    this.masechtaService.getGemaraMasechtas()
      .then(masechtas => this.gemaraMasechtas = masechtas);

    this.masechtaService.getMishnaMasechtas()
      .then(masechtas => this.mishnaMasechtas = masechtas);

    this.loadDafs();

  }



  loadDafs() {
    for (let i=2; i<=176; i++) {
      this.dafs.push({
        name: this.hebrewService.getHebrewNumber(i),
        value: i,
      });
    }
  }




  saveSource() {

    if (this.source.sourceType == 'gemara') {
      if (this.gemaraStartLocation_daf  && this.gemaraStartLocation_amud) {
        this.source.gemaraStartLocation = {
          daf: this.gemaraStartLocation_daf,
          amud: this.gemaraStartLocation_amud,
        };

        if (this.gemaraEndLocation_daf  && this.gemaraEndLocation_amud) {
          this.source.isRange = true;
          this.source.gemaraEndLocation = {
            daf: this.gemaraEndLocation_daf,
            amud: this.gemaraEndLocation_amud,
          };
        }

        this.source.renderTextShort = this.hebrewService.getSourceRenderTextShort(this.source);
        this.source.renderTextFull = this.hebrewService.getSourceRenderTextFull(this.source);

        this.dialogRef.close(this.source);

      } else {
        this.dialogRef.close('error');
      }
    }

    if (this.source.sourceType == 'mishna') {
      if (this.mishnaStartLocation_perek  && this.mishnaStartLocation_mishna) {
        this.source.mishnaStartLocation = {
          perek: this.mishnaStartLocation_perek,
          mishna: this.mishnaStartLocation_mishna,
        };

        if (this.mishnaEndLocation_perek  && this.mishnaEndLocation_mishna) {
          this.source.isRange = true;
          this.source.mishnaEndLocation = {
            perek: this.mishnaEndLocation_perek,
            mishna: this.mishnaEndLocation_mishna,
          };
        }

        this.source.renderTextShort = this.hebrewService.getSourceRenderTextShort(this.source);
        this.source.renderTextFull = this.hebrewService.getSourceRenderTextFull(this.source);

        this.dialogRef.close(this.source);

      } else {
        this.dialogRef.close('error');
      }
    }

    if (this.source.sourceType == 'literal') {
      this.source.isLiteral = true;
      this.source.renderTextShort = this.hebrewService.getSourceRenderTextShort(this.source);
      this.source.renderTextFull = this.hebrewService.getSourceRenderTextFull(this.source);
      this.dialogRef.close(this.source);
    }


  }



}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/source-dialog/source-dialog.ts